"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ConnectionManager_1 = require("../../ConnectionManager");
var GameConstants_1 = require("../../GameConstants");
var GameVars_1 = require("../../GameVars");
var LocalServer_1 = require("../../LocalServer");
var BoardManager_1 = require("../BoardManager");
var BoardState_1 = require("../BoardState");
var Card_1 = require("./Card");
var DealPile = /** @class */ (function (_super) {
    __extends(DealPile, _super);
    function DealPile(game) {
        var _this = _super.call(this, game, null, "deal-pile") || this;
        _this.piledCards = [];
        _this.piledCardsAux = [];
        _this.onTween = false;
        var emptyPileImage = new Phaser.Image(_this.game, 0, 0, "texture_atlas_1", "empty-deal-pile");
        emptyPileImage.scale.y = GameVars_1.GameVars.scaleY;
        emptyPileImage.inputEnabled = true;
        emptyPileImage.events.onInputUp.add(_this.moveCards, _this);
        _this.add(emptyPileImage);
        return _this;
    }
    DealPile.prototype.moveCards = function () {
        if (GameVars_1.GameVars.waitingServer) {
            return;
        }
        if (!Card_1.Card.tweening) {
            var cardAux = void 0;
            while (this.piledCardsAux.length !== 0) {
                cardAux = this.piledCardsAux.shift();
                this.piledCards.push(cardAux);
                cardAux.unflip();
                cardAux.movePos(658 + 53, GameConstants_1.GameConstants.DEALPILE_Y);
            }
            BoardManager_1.BoardManager.currentInstance.saveChange();
            if (GameVars_1.GameVars.gzpGameMode !== "casual") {
                ConnectionManager_1.ConnectionManager.socket.emit("move_cards", { id: GameVars_1.GameVars.initialID });
                BoardManager_1.BoardManager.currentInstance.showWaitingServer();
            }
            else {
                BoardManager_1.BoardManager.currentInstance.showWaitingServer();
                LocalServer_1.LocalServer.moveCardsClient();
            }
        }
    };
    DealPile.prototype.shuffle = function () {
        this.moveCards();
        Card_1.Card.tweening = true;
        this.game.time.events.add(250, function () {
            var _a;
            if (this.piledCards.length) {
                for (var i = this.piledCards.length - 1; i > 0; i--) {
                    var j = Math.floor(Math.random() * (i + 1));
                    _a = [this.piledCards[j], this.piledCards[i]], this.piledCards[i] = _a[0], this.piledCards[j] = _a[1];
                }
                for (var i = 0; i < this.piledCards.length; i++) {
                    this.piledCards[i].sendToBack();
                }
                BoardState_1.BoardState.currentInstance.board.sendToBack(this);
                if (this.piledCards[1]) {
                    this.game.add.tween(this.piledCards[1])
                        .to({ y: this.piledCards[1].y - 20 }, 100, Phaser.Easing.Cubic.Out, true)
                        .onComplete.add(function () {
                        this.game.add.tween(this.piledCards[1])
                            .to({ y: this.piledCards[1].y + 20 }, 100, Phaser.Easing.Cubic.In, true);
                    }, this);
                }
                if (this.piledCards[2]) {
                    this.game.add.tween(this.piledCards[2])
                        .to({ x: this.piledCards[2].x - 15 }, 100, Phaser.Easing.Cubic.Out, true, 75)
                        .onComplete.add(function () {
                        this.game.add.tween(this.piledCards[2])
                            .to({ x: this.piledCards[2].x + 15 }, 100, Phaser.Easing.Cubic.In, true, 75);
                    }, this);
                }
                if (this.piledCards[3]) {
                    this.game.add.tween(this.piledCards[3])
                        .to({ y: this.piledCards[3].y + 25 }, 120, Phaser.Easing.Cubic.Out, true, 100)
                        .onComplete.add(function () {
                        this.game.add.tween(this.piledCards[3])
                            .to({ y: this.piledCards[3].y - 25 }, 120, Phaser.Easing.Cubic.In, true, 100);
                    }, this);
                }
                if (this.piledCards[4]) {
                    this.game.add.tween(this.piledCards[4])
                        .to({ x: this.piledCards[4].x + 20 }, 120, Phaser.Easing.Cubic.Out, true, 125)
                        .onComplete.add(function () {
                        this.game.add.tween(this.piledCards[4])
                            .to({ x: this.piledCards[4].x - 20 }, 120, Phaser.Easing.Cubic.In, true, 125);
                    }, this);
                }
            }
        }, this);
        this.game.time.events.add(500, function () {
            Card_1.Card.tweening = false;
        }, this);
    };
    DealPile.prototype.setPosition = function (x, y) {
        this.x = x;
        this.y = y;
    };
    DealPile.prototype.addCard = function (card) {
        this.piledCards.push(card);
    };
    DealPile.prototype.removeCard = function (card) {
        card.dealPile = false;
        var index = this.piledCards.indexOf(card);
        if (index > -1) {
            this.piledCards.splice(index, 1);
        }
    };
    DealPile.prototype.nextCard = function () {
        if (this.piledCards.length !== 0) {
            var card = this.piledCards.shift();
            this.piledCardsAux.push(card);
            card.movePos(658 - 109 + 53, GameConstants_1.GameConstants.DEALPILE_Y);
            card.flip();
            card.bringToTop();
        }
    };
    DealPile.prototype.next3Cards = function () {
        Card_1.Card.tweening = true;
        this.game.time.events.add(300, function () {
            Card_1.Card.tweening = false;
        }, this);
        for (var i = 0; i < this.piledCardsAux.length; i++) {
            this.piledCardsAux[i].movePos(658 - 169 + 53, GameConstants_1.GameConstants.DEALPILE_Y);
        }
        for (var i = 0; i < 3; i++) {
            if (this.piledCards.length !== 0) {
                var card = this.piledCards.shift();
                this.piledCardsAux.push(card);
                card.movePos(658 - 169 + 53 + 30 * i, GameConstants_1.GameConstants.DEALPILE_Y);
                card.flip();
                card.bringToTop();
            }
        }
    };
    DealPile.prototype.deleteCard = function (card) {
        card.dealPile = false;
        var index = this.piledCardsAux.indexOf(card);
        if (index > -1) {
            this.piledCardsAux.splice(index, 1);
        }
    };
    DealPile.prototype.cardOnDealTop = function (card) {
        return card === this.piledCardsAux[this.piledCardsAux.length - 1];
    };
    return DealPile;
}(Phaser.Group));
exports.DealPile = DealPile;
